'use client';

import { useState } from 'react';
import Icon from '@/components/ui/AppIcon';

interface FAQItem {
  id: string;
  question: string;
  answer: string;
}

export default function BulkPricingSection() {
  const [openId, setOpenId] = useState<string | null>(null);

  const faqs: FAQItem[] = [
    {
      id: 'bulk_1',
      question: 'Do you offer wholesale pricing?',
      answer: 'Yes, we offer competitive wholesale pricing for bulk orders. Wholesale rates are available for agro-vet shops, large-scale farmers, poultry cooperatives, and authorized distributors. Contact our sales team at 0777 014 115 or 0704 846 600 to discuss wholesale pricing tailored to your order volume.'
    },
    {
      id: 'bulk_2',
      question: 'What volume discounts are available?',
      answer: 'Volume discounts are structured in tiers based on order quantity. Larger orders receive progressively better pricing. We also offer special rates for regular customers who commit to monthly or quarterly orders. Contact us for a detailed pricing structure based on your expected order volumes.'
    },
    {
      id: 'bulk_3',
      question: 'What are the pricing tiers?',
      answer: 'Our pricing tiers are based on order volume and customer type. Tier 1 applies to small orders, Tier 2 for medium bulk orders, and Tier 3 for large wholesale and distributor orders. Each tier offers progressively better unit pricing. For specific tier thresholds and pricing, please contact our sales team for a customized quote.'
    }
  ];

  const toggleFAQ = (id: string) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <section className="py-section-sm px-6">
      <div className="max-w-4xl mx-auto">
        <div className="mb-12">
          <h2 className="text-heading-3 text-foreground mb-4">Bulk Pricing</h2>
          <p className="text-muted-foreground">
            Learn about wholesale pricing, volume discounts, and pricing tiers for bulk orders.
          </p>
        </div>

        <div className="space-y-4">
          {faqs?.map((faq) => (
            <div
              key={faq?.id}
              className="bg-white rounded-lg border border-border overflow-hidden transition-all hover:shadow-md"
            >
              <button
                onClick={() => toggleFAQ(faq?.id)}
                className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-secondary/5 transition-colors"
              >
                <span className="font-semibold text-foreground pr-4">{faq?.question}</span>
                <Icon
                  name={openId === faq?.id ? 'ChevronUpIcon' : 'ChevronDownIcon'}
                  size={20}
                  className="text-primary flex-shrink-0"
                />
              </button>
              {openId === faq?.id && (
                <div className="px-6 pb-5 text-muted-foreground leading-relaxed">
                  {faq?.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}